// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input_container__hfZjQ {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative; }
  .input_container__hfZjQ .input_required_label__f-IIm {
    content: '*';
    color: var(--Orange); }

.input_label__j-IUX {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--HightEmphasis);
  margin-bottom: 6px; }

.input_block__yQK0F {
  position: relative; }
  .input_block__input__GNGUf {
    width: 100%;
    max-height: 50px;
    border: 1px solid var(--LowEmphasis);
    border-radius: 4px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: var(--HightEmphasis);
    padding: 13px 16px; }
    .input_block__input__GNGUf:focus {
      border-color: #212121;
      outline: none; }
  .input_block__eye__ZRmvy {
    cursor: pointer;
    position: absolute;
    top: calc(50% - 12.5px);
    right: 12px;
    width: 25px;
    height: 25px;
    color: var(--MediumEmphasis); }
    .input_block__eye__ZRmvy:hover {
      color: var(--HightEmphasis); }
  .input_block__search__Gw6pi {
    position: absolute;
    right: 0px; }
  .input_block__error__NRcrd {
    border: 1px solid var(--Red) !important; }
  .input_block__error__NRcrd::placeholder {
    color: var(--Red); }
  .input_block__error_message__V9yfD {
    position: absolute;
    bottom: -24px;
    left: 0;
    font-weight: 400;
    font-size: 12px;
    line-height: 24px;
    color: var(--Red); }
`, "",{"version":3,"sources":["webpack://./src/components/input/input.module.scss","webpack://./src/styles/fonts.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB,EAAA;EAJpB;IAOI,YAAY;IACZ,oBAAoB,EAAA;;AAIxB;ECsBE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EDtBjB,2BAA2B;EAC3B,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB,EAAA;EAClB;IACE,WAAW;IACX,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;ICUpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDVf,2BAA2B;IAC3B,kBAAkB,EAAA;IAPnB;MASG,qBAAqB;MACrB,aAAa,EAAA;EAGjB;IACE,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,4BAA4B,EAAA;IAP7B;MASG,2BAA2B,EAAA;EAG/B;IACE,kBAAkB;IAClB,UAAU,EAAA;EAEZ;IACE,uCAAuC,EAAA;EAEzC;IACE,iBAAiB,EAAA;EAEnB;IACE,kBAAkB;IAClB,aAAa;IACb,OAAO;ICMT,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDNf,iBAAiB,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n\n.container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  position: relative;\n\n  .required_label {\n    content: '*';\n    color: var(--Orange);\n  }\n}\n\n.label {\n  @include body1;\n  color: var(--HightEmphasis);\n  margin-bottom: 6px;\n}\n\n.block {\n  position: relative;\n  &__input {\n    width: 100%;\n    max-height: 50px;\n    border: 1px solid var(--LowEmphasis);\n    border-radius: 4px;\n    @include body1;\n    color: var(--HightEmphasis);\n    padding: 13px 16px;\n    &:focus {\n      border-color: #212121;\n      outline: none;\n    }\n  }\n  &__eye {\n    cursor: pointer;\n    position: absolute;\n    top: calc(50% - 12.5px);\n    right: 12px;\n    width: 25px;\n    height: 25px;\n    color: var(--MediumEmphasis);\n    &:hover {\n      color: var(--HightEmphasis);\n    }\n  }\n  &__search {\n    position: absolute;\n    right: 0px;\n  }\n  &__error {\n    border: 1px solid var(--Red) !important;\n  }\n  &__error::placeholder {\n    color: var(--Red);\n  }\n  &__error_message {\n    position: absolute;\n    bottom: -24px;\n    left: 0;\n    @include caption;\n    color: var(--Red);\n  }\n}\n","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `input_container__hfZjQ`,
	"required_label": `input_required_label__f-IIm`,
	"label": `input_label__j-IUX`,
	"block": `input_block__yQK0F`,
	"block__input": `input_block__input__GNGUf`,
	"block__eye": `input_block__eye__ZRmvy`,
	"block__search": `input_block__search__Gw6pi`,
	"block__error": `input_block__error__NRcrd`,
	"block__error_message": `input_block__error_message__V9yfD`
};
export default ___CSS_LOADER_EXPORT___;
